import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { AttributeApiModel } from '@rocksoft/inroom-sdk';

export const inRoomAttribuesFeatureKey = 'attributesw';

export interface Attributes {
  reservationId: string;
  attributes: AttributeApiModel[];
}

export function selectAttributesIdFrom(state: Attributes): string {
  return state.reservationId;
}

export const adapter: EntityAdapter<Attributes> = createEntityAdapter<Attributes>({
  selectId: selectAttributesIdFrom,
});

export type AttributesState = EntityState<Attributes>;

export const initialState: AttributesState = adapter.getInitialState();
